import { STEPS } from "@/lib/vgt";
import { Reveal, SectionHeader } from "./Reveal";

export const Ordering = () => (
  <section id="ordering" data-testid="ordering-section" className="py-20 sm:py-28 px-4 sm:px-8">
    <div className="max-w-5xl mx-auto">
      <SectionHeader
        eyebrow="03 · How B2B Ordering Works"
        title="From Inquiry to Your Door in Four Steps"
      />
      <ol>
        {STEPS.map((s, i) => (
          <Reveal key={s.step} delay={i * 0.05}>
            <li
              data-testid={`ordering-step-${i}`}
              className="grid sm:grid-cols-[130px_1fr] gap-3 sm:gap-10 py-9 sm:py-11 border-t border-[#E6DEC3] last:border-b items-start"
            >
              <span className="font-serif font-bold text-5xl sm:text-6xl text-[#D4A359] leading-none">
                {s.step}
              </span>
              <div>
                <h3 className="font-serif font-bold text-xl sm:text-2xl text-[#2C1A0C]">{s.title}</h3>
                <p className="mt-2.5 text-sm sm:text-base text-[#6E5B4F] leading-relaxed max-w-2xl">{s.desc}</p>
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
